import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function BlockedPeople({ notify }) {
  const [people, setPeople] = useState(null);
  const load = () => api.blocked().then(setPeople).catch(() => setPeople([]));
  useEffect(() => { load(); }, []);
  if (people === null) return null;
  return (
    <div className="notif-settings">
      {people.length === 0 && <p className="muted-sm">You haven't blocked anyone.</p>}
      {people.map((p) => (
        <div key={p.id} className="invite-item">
          <div className="invite-main"><b>{p.name}</b><span className="muted-sm">{p.headline}</span></div>
          <button className="btn quiet sm" onClick={() => api.unblock(p.id).then(() => { notify?.(`${p.name} unblocked`); load(); }).catch((e) => notify?.(e.message))}>
            Unblock
          </button>
        </div>
      ))}
      <p className="muted-sm">
        <a href="/privacy" target="_blank" rel="noreferrer">Privacy Policy</a> ·{' '}
        <a href="/terms" target="_blank" rel="noreferrer">Terms of Use</a>
      </p>
    </div>
  );
}
